import { render, staticRenderFns } from "./UpperPart.vue?vue&type=template&id=4c7a04fa&scoped=true&"
import script from "./UpperPart.vue?vue&type=script&lang=js&"
export * from "./UpperPart.vue?vue&type=script&lang=js&"
import style0 from "./UpperPart.vue?vue&type=style&index=0&id=4c7a04fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a04fa",
  null
  
)

export default component.exports